import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const TabContainer = styled(Flex)`
  margin-top: 10px;
  width: ${props => (props?.width ? props?.width : 'fit-content')};
  justify-content: center;
  align-items: center;

  border: ${props =>
    props?.customBorder
      ? 'none'
      : props?.activeStyle?.border
      ? props?.activeStyle?.border
      : '1px solid #e3deff'};

  border-radius: ${props =>
    props?.activeStyle?.borderRadius
      ? props?.activeStyle?.borderRadius
      : '10px'};
  cursor: ${props => (props?.disabled ? 'not-allowed' : 'pointer')};
  background: ${props =>
    props?.disabled ? COLORS.DISABLED_SECONDARY : 'white'};
  height: ${props =>
    props?.activeStyle?.height ? props?.activeStyle?.height : '38px'};
  margin-bottom: ${props =>
    props?.tabMarginBottom ? props?.tabMarginBottom : '10px'};
  border-bottom: 1px solid #e3deff;
`

export const TabChildItem = styled.div`
  font-weight: ${props =>
    props?.normalFontWeight ? props?.normalFontWeight : FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props =>
    props.active
      ? props?.activeStyle?.color
        ? props?.activeStyle?.color
        : '#FBFAFF'
      : props?.normalTextColor
      ? props?.normalTextColor
      : '#3249D7'};
  background-color: ${props =>
    props.active
      ? props?.activeStyle?.background
        ? props?.activeStyle?.background
        : '#3249D7'
      : 'unset'};
  padding: 10px 20px;
  border-radius: ${props =>
    props?.activeStyle?.borderRadius
      ? props?.activeStyle?.borderRadius
      : '8px'};
  transition: 0.5s;
  pointer-events: ${props =>
    props?.disabled ? 'none' : props?.pointerEventsNone ? 'none' : 'auto'};
  opacity: ${props => (props?.disabled ? '0.5' : '1')};
  border: ${props =>
    props?.activeStyle?.border
      ? props?.activeStyle?.border
      : props.active
      ? '1px solid #e3deff'
      : 'none'};
  flex: ${props => (props?.equalSpace ? '1 1 0%' : 'unset')};
  text-align: ${props => (props?.alignText ? props?.alignText : 'left')};
  border-bottom: ${props =>
    props?.activeStyle?.borderBottom && props?.active
      ? props?.activeStyle?.borderBottom
      : 'unset'};
  height: ${props => props?.activeStyle?.height};
  border-left: ${props =>
    props?.showBorderBetween ? '1px solid  #e3deff' : 'unset'};
  border-right: ${props =>
    props?.showBorderBetween ? '1px solid  #e3deff' : 'unset'};
`

export const Container = styled(Flex)`
  margin-top: 10px;
  width: fit-content;
  justify-content: center;
  align-items: center;
  padding: 3px 4px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  cursor: ${props => (props?.disabled ? 'not-allowed' : 'pointer')};
  background: ${props =>
    props?.disabled ? COLORS.DISABLED_SECONDARY : 'white'};
`

export const Left = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props => props.color};
  background-color: ${props => props.background};
  padding: 10px 20px;
  border-radius: 8px;
  transition: 0.5s;
  pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
  opacity: ${props => (props?.disabled ? '0.5' : '1')};
  width: ${props => (props?.width ? props.width : '')};
`

export const Right = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props => props.color};
  background-color: ${props => props.background};
  padding: 10px 20px;
  border-radius: 8px;
  transition: 0.5s;
  pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
  width: ${props => (props?.width ? props.width : '')};
`
export const Center = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props => props.color};
  background-color: ${props => props.background};
  padding: 10px 20px;
  border-radius: 8px;
  transition: 0.5s;
  pointer-events: ${props => (props?.disabled ? 'none' : 'auto')};
`
